import SearchResult from '../../components/SearchResults';
import Nav from '../../components/Nav';

function Search() {
    return(
        <div>
            <Nav />
            <SearchResult/>
        </div>
    )
}

export default Search;